<template lang="pug">
#modal-analise-elegibilidade
    el-dialog.modal-analise-elegibilidade(
        :visible.sync='show',
        width='80%',
        :before-close='handleCloseModal',
        :close-on-click-modal='false',
        :fullscreen='false',
        append-to-body,
        destroy-on-close
    )
        span(slot='title')
            h3.modal-analise-elegibilidade--header.mr-1 {{ $t('mensagens.relatorioRastreabilidade.cadastro.analiseElegibilidade') }}:
                .analise-elegibilidade--header__status
                    .analise-elegibilidade--header__status-diagnostico(
                        :class='statusElegibilidade[dados.elegibilidade] ? statusElegibilidade[dados.elegibilidade].classeCor : ""'
                    )
                        i.mdi.mdi-check-circle(
                            v-if='dados.elegibilidade === "ELEGIVEL"'
                        )
                        i.mdi.mdi-information.font-size-mdi(
                            v-else-if='dados.elegibilidade === "ALERTA"'
                        )
                        i.flow.flow-warning-sign(
                            v-else-if='dados.elegibilidade === "INELEGIVEL"'
                        )

                        span
                        | {{ statusElegibilidade[dados.elegibilidade] ? statusElegibilidade[dados.elegibilidade].status : '' }}

        .modal-analise-elegibilidade--body
            .direita.lista-scroll
                .modal-analise-elegibilidade--sub-title
                    i.mdi.mdi-check-circle(
                        v-if='classeDiagnosticoCar === "BAIXO"',
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    i.mdi.mdi-information.font-size-mdi(
                        v-else-if='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    i.flow.flow-warning-sign.mr-1(
                        v-else,
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    h4.direita-sub-title {{ $t('mensagens.relatorioRastreabilidade.cadastro.diagnosticoSocioambiental') }}
                .modal-analise-bloco
                    .modal-analise-bloco--title
                        .modal-analise-bloco--title--car
                            span CAR:
                        .modal-analise-bloco--title--descricao
                            span
                            |
                            | {{ dados.dadosDiagnostico?.diagnosticoCar?.imovel.codigo }}

                    .modal-analise-bloco--conteudo
                        span.modal-analise-bloco--conteudo--interno
                            .modal-analise-bloco--conteudo--interno--title {{ $t('mensagens.relatorioRastreabilidade.cadastro.situacaoCadastro') }}
                            | {{ exibirSatausSituacao(dados.dadosDiagnostico?.diagnosticoCar?.imovel.situacao) }}

                        span.modal-analise-bloco--conteudo--interno
                            .modal-analise-bloco--conteudo--interno--title {{ $t('mensagens.relatorioRastreabilidade.cadastro.condicaoCadastro') }}
                            | {{ dados.dadosDiagnostico?.diagnosticoCar?.imovel.condicao }}

                        span.modal-analise-bloco--conteudo--interno
                            .modal-analise-bloco--conteudo--interno--title {{ $t('mensagens.relatorioRastreabilidade.cadastro.areaImovel') }}
                            | {{ dados.dadosDiagnostico?.diagnosticoCar?.imovel.areaHa }} ha
                    hr
                    .modal-analise-bloco-lista-scroll
                        el-collapse(
                            v-model='collapseAtivo',
                            @change='exibirRestricoesNoMapa',
                            accordion
                        )
                            el-collapse-item(
                                v-for='(diagnostico, index) in dados.dadosDiagnostico?.diagnosticoCar?.diagnosticos',
                                v-if='diagnostico.nivelAlerta !== "BAIXO"',
                                :key='index',
                                :name='index'
                            )
                                template(slot='title')
                                    i.mr-2.flow.flow-warning-sign.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "ALTO"',
                                        :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                    )
                                    i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                        v-else='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                                        :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                    )
                                    span
                                    | {{ diagnostico.camada.nome }}

                                    div(v-if='diagnostico.resultados.length')
                                        el-tag.custon-tag(
                                            size='mini',
                                            type='danger'
                                        ) {{ diagnostico.resultados.length }}

                                div(
                                    v-if='diagnostico && diagnostico.resultados.length'
                                )
                                    component(
                                        ref='componente',
                                        v-bind:is='prepararComponente(diagnostico)',
                                        v-bind='prepararDadosParaComponente(diagnostico)',
                                        @aplicar-zoom-restricao='aplicarZoomRestricao'
                                    )

                                .container-sem-restricoes(
                                    v-if='diagnostico.resultados.length === 0'
                                )
                                    p {{ $t('mensagens.relatorioRastreabilidade.cadastro.naoHaRestricoes') }}

                                Fonte(
                                    :fonte='diagnostico?.camada?.fonte ? diagnostico.camada.fonte : {}',
                                    collapse-class='my-3'
                                )

                        p(
                            v-if='classeDiagnosticoCar === "BAIXO"',
                            :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                        ) {{ $t('mensagens.relatorioRastreabilidade.cadastro.nenhumaInconformidadeEncontrada') }}

                .modal-analise-bloco.modal-analise-bloco__baixo
                    .modal-analise-bloco-cpf-cnpj
                        span.titulo CPF/CNPJ:
                        | {{ dados.cpfCnpj }}

                    .modal-analise-bloco-lista-scroll
                        el-collapse(v-model='collapseAtivoPessoa', accordion)
                            el-collapse-item(
                                v-for='(diagnostico, index) in dados.dadosDiagnostico?.diagnosticoRepresentante',
                                v-if='diagnostico.nivelAlerta !== "BAIXO"',
                                :key='index',
                                :name='index'
                            )
                                template(slot='title')
                                    i.mr-2.flow.flow-warning-sign.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "ALTO"',
                                        :class='"vermelho"'
                                    )
                                    i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                        v-else,
                                        :class='"status-amarelo"'
                                    )

                                    span {{ diagnostico.camada.nome }}

                                    div(v-if='diagnostico.resultados.length')
                                        el-tag.custon-tag(
                                            size='mini',
                                            type='danger'
                                        ) {{ diagnostico.resultados.length }}

                                div(
                                    v-if='diagnostico && diagnostico.resultados.length'
                                )
                                    component(
                                        ref='componente',
                                        v-bind:is='prepararComponente(diagnostico)',
                                        v-bind='prepararDadosParaComponente(diagnostico)',
                                        @aplicar-zoom-restricao='aplicarZoomRestricao'
                                    )

                                .container-sem-restricoes(
                                    v-if='diagnostico.resultados.length === 0'
                                )
                                    p {{ $t('mensagens.relatorioRastreabilidade.cadastro.naoHaRestricoes') }}

                                Fonte(
                                    :fonte='diagnostico?.camada?.fonte ? diagnostico.camada.fonte : {}',
                                    collapse-class='my-3'
                                )

                    p.status-sucess(v-if='!restricaoRepresentante') {{ $t('mensagens.relatorioRastreabilidade.cadastro.nenhumaInconformidadeEncontrada') }}

                .bloco-capacidade-produtiva--sub-title
                    i.mdi.mdi-check-circle.status-sucess(
                        v-if='dados.dadosBuscaSaldo?.saldoCARcapacidadeProdutiva >= 0'
                    )
                    i.mdi.mdi-check-circle.status-danger(v-else)
                    h4.direita-sub-title {{ $t('mensagens.relatorioRastreabilidade.cadastro.capacidadeProdutiva') + ' (' + $t('mensagens.relatorioRastreabilidade.cadastro.areaConsolidada') + ')' }}
                .modal-analise-bloco
                    .bloco-capacidade-produtiva--conteudo
                        span.bloco-capacidade-produtiva--conteudo--interno
                            .bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.relatorioRastreabilidade.cadastro.area') }}
                            | {{ dadosProdutividade.area ? formatNumber(dadosProdutividade.area) : '---' }} ha

                        .bloco-capacidade-produtiva--conteudo-baixo
                            .bloco-capacidade-produtiva--conteudo-baixo--interno
                                el-tooltip(
                                    placement='top',
                                    :content='`${$t("mensagens.relatorioRastreabilidade.cadastro.fonte")}: ${dadosProdutividade.fonteDados.nome}`'
                                )
                                    span
                                        i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                        span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.relatorioRastreabilidade.cadastro.produtividade') }}
                                | {{ dadosProdutividade.produtividade ? dadosProdutividade.produtividade : '---' }} {{ dadosProdutividade.produtividadeUnidadeMedida }} ({{ dadosProdutividade.calculoSaca.mediaRegional ? dadosProdutividade.calculoSaca.mediaRegional : '---' }} sc/ha)

                        .bloco-capacidade-produtiva--conteudo-baixo
                            span.bloco-capacidade-produtiva--conteudo--interno
                                el-tooltip(
                                    placement='top',
                                    :content='`(${$t("mensagens.relatorioRastreabilidade.cadastro.produtividade")} x ${$t("mensagens.relatorioRastreabilidade.cadastro.areaConsolidada")}) x ${capacidadeProdutivaFatorProdutividade}`'
                                )
                                    span
                                        i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                        span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.relatorioRastreabilidade.cadastro.capacidadeProdutiva') }}
                                | {{ dadosProdutividade?.capacidadeProdutiva }} t ({{ dadosProdutividade.calculoSaca.produtividade }} sc)

            .esquerda
                .mapa-elegibilidade
                    Mapa(
                        ref='mapa',
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :height='"93%"',
                        :idMapa='idMapa'
                    )

        span(slot='footer')
            el-button(type='primary', @click='handleCloseModal') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import TerraIndigena from '@/components/diagnosticoSocioambiental/TerraIndigena.vue';
import AmazoniaProtege from '@/components/diagnosticoSocioambiental/AmazoniaProtege.vue';
import AreaEmbargada from '@/components/diagnosticoSocioambiental/AreaEmbargada.vue';
import Prodes from '@/components/diagnosticoSocioambiental/Prodes.vue';
import AreaEmbargadaIcmbio from '@/components/diagnosticoSocioambiental/AreaEmbargadaIcmbio.vue';
import AreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/AreaEmbargadaSemaMt.vue';
import AreaEmbargadaGoias from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoias.vue';
import PovosComunidadesTradicionais from '@/components/diagnosticoSocioambiental/PovosComunidadesTradicionais.vue';
import Ldi from '@/components/diagnosticoSocioambiental/Ldi.vue';
import ListaAreaEmbargada from '@/components/diagnosticoSocioambiental/ListaAreaEmbargada.vue';
import ProtocoloVerdeGraos from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraos.vue';
import ListaSujaTrabalhoEscravo from '@/components/diagnosticoSocioambiental/ListaSujaTrabalhoEscravo.vue';
import ProdesCerrado from '@/components/diagnosticoSocioambiental/ProdesCerrado.vue';
import DeterAmazonia from '@/components/diagnosticoSocioambiental/DeterAmazonia.vue';
import DeterCerrado from '@/components/diagnosticoSocioambiental/DeterCerrado.vue';
import UnidadeConservacaoUs from '@/components/diagnosticoSocioambiental/UnidadeConservacaoUs.vue';
import UnidadeConservacaoPi from '@/components/diagnosticoSocioambiental/UnidadeConservacaoPi.vue';
import Queimadas from '@/components/diagnosticoSocioambiental/Queimadas.vue';
import SitiosArqueologicos from '@/components/diagnosticoSocioambiental/SitiosArqueologicos.vue';
import FaixaFronteira from '@/components/diagnosticoSocioambiental/FaixaFronteira.vue';
import PocAreaPlantadaGameleira from '@/components/diagnosticoSocioambiental/PocAreaPlantadaGameleira.vue';
import ImovelRural from '@/components/diagnosticoSocioambiental/ImovelRural.vue';
import Biomas from '@/components/diagnosticoSocioambiental/Biomas.vue';
import IncraSigefPublico from '@/components/diagnosticoSocioambiental/IncraSigefPublico.vue';
import IncraSigefPrivado from '@/components/diagnosticoSocioambiental/IncraSigefPrivado.vue';
import IncraAssentamentos from '@/components/diagnosticoSocioambiental/IncraAssentamentos.vue';
import IncraQuilombolas from '@/components/diagnosticoSocioambiental/IncraQuilombolas.vue';
import QuilombolasMaranhao from '@/components/diagnosticoSocioambiental/QuilombolasMaranhao.vue';
import DesmatamentoMapbiomas from '@/components/diagnosticoSocioambiental/desmatamento-mapbiomas.vue';
import AreaRelevanteInteresseEcologicoArie from '@/components/diagnosticoSocioambiental/AreaRelevanteInteresseEcologicoArie.vue';
import AreaProtecaoAmbientalApa from '@/components/diagnosticoSocioambiental/AreaProtecaoAmbientalApa.vue';
import AppCamada from '@/components/diagnosticoSocioambiental/AppCamada.vue';
import ReservaLegal from '@/components/diagnosticoSocioambiental/ReservaLegal.vue';
import UnidadeConservacao from '@/components/diagnosticoSocioambiental/UnidadeConservacao.vue';
import AreaPlantadaSojaCarMapbiomas from '@/components/diagnosticoSocioambiental/AreaPlantadaSojaCarMapbiomas.vue';
import AreaEmbargadaSedamRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaSedamRo.vue';
import ListaAreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaSemaMt.vue';
import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import AreaEmbargadaGdf from '@/components/diagnosticoSocioambiental/AreaEmbargadaGdf.vue';
import TermoEmbargoIpaam from '../diagnosticoSocioambiental/TermoEmbargoIpaam.vue';
import AutosInfracaoFiscalizacaoIpaam from '../diagnosticoSocioambiental/AutosInfracaoFiscalizacaoIpaam.vue';
import AutosEmbargosIpaamPol from '../diagnosticoSocioambiental/AutosEmbargosIpaamPol.vue';
import EmbargosRemotosIpaam from '../diagnosticoSocioambiental/EmbargosRemotosIpaam.vue';
import AutoInfracaoGoPoligono from '../diagnosticoSocioambiental/AutoInfracaoGoPoligono.vue';
import AutoInfracaoGoPonto from '../diagnosticoSocioambiental/AutoInfracaoGoPonto.vue';
import AutoInfracaoIpaam from '../diagnosticoSocioambiental/AutoInfracaoIpaam.vue';
import EmbargosEmergenciaisIpaam from '../diagnosticoSocioambiental/EmbargosEmergenciaisIpaam.vue';
import AreaEmbargadaAutoInfracaoSp from '../diagnosticoSocioambiental/AreaEmbargadaAutoInfracaoSp.vue';
import AreaEmbargadaRs from '@/components/diagnosticoSocioambiental/AreaEmbargadaRs.vue';
import AreaEmbargadaGoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoPonto.vue';
import AreasEmbargadasTo from '@/components/diagnosticoSocioambiental/AreasEmbargadasTo.vue';
import AutoInfracaoTo from '@/components/diagnosticoSocioambiental/AutoInfracaoTo.vue';
import EmbargosGoLista from '@/components/diagnosticoSocioambiental/EmbargosGoLista.vue';
import AutoInfracaoRs from '@/components/diagnosticoSocioambiental/AutoInfracaoRs.vue';
import QuilombolasBa from '@/components/diagnosticoSocioambiental/QuilombolasBa.vue';
import CsaCerrado from '@/components/diagnosticoSocioambiental/CsaCerrado.vue';
import AutoInfracaoPi from '@/components/diagnosticoSocioambiental/AutoInfracaoPi.vue';
import AreaEmbargadaPa from '@/components/diagnosticoSocioambiental/AreaEmbargadaPa.vue';
import AreaEmbargadaCePonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaCePonto.vue';
import AreaEmbargadaCe from '@/components/diagnosticoSocioambiental/AreaEmbargadaCe.vue';
import AreaEmbargadaIbamaPoligonoPamgia from '@/components/diagnosticoSocioambiental/AreaEmbargadaIbamaPoligonoPamgia.vue';
import AreaEmbargadaRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaRo.vue';
import AreaEmbargadaRoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaRoPonto.vue';
import ControleDesmatamentoAmazonia from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazonia.vue';
import ControleDesmatamentoAmazoniaPontos from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazoniaPontos.vue';
import ControleDesmatamentoAmazoniaConsolidada from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazoniaConsolidada.vue';
import AreaPlantadaBunge2024 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2024.vue';
import AreaPlantadaBunge2025 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2025.vue';
import AreaPlantadaBunge2026 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2026.vue';
import SojaEmProdes2425 from '@/components/diagnosticoSocioambiental/SojaEmProdes2425.vue';
import ProtocoloVerdeGraosStatusOk from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraosStatusOk.vue';
import ProtocoloVerdeGraosStatusRestricao from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraosStatusRestricao.vue';
import TerraIndigenaStatusDelimitado from '@/components/diagnosticoSocioambiental/TerraIndigenaStatusDelimitado.vue';
import TerraIndigenaStatusDeclarado from '@/components/diagnosticoSocioambiental/TerraIndigenaStatusDeclarado.vue';
import EmbargoGoInaConsultaLista from '../diagnosticoSocioambiental/EmbargoGoInaConsultaLista.vue';
import DenunciasProdutoresBunge from '@/components/diagnosticoSocioambiental/DenunciasProdutoresBunge.vue';

import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import formatters from '@/utils/formatters';
const restricaoPattern =
    'https://lyra-bunge-publico.s3.amazonaws.com/restricao_pattern.gif';

export default {
    name: 'ModalAnaliseElegibilidadeRelatorio',
    components: {
        Mapa,
        TerraIndigena,
        AmazoniaProtege,
        AreaEmbargada,
        Prodes,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        AreaEmbargadaGoias,
        PovosComunidadesTradicionais,
        Ldi,
        ListaAreaEmbargada,
        ProtocoloVerdeGraos,
        ListaSujaTrabalhoEscravo,
        ProdesCerrado,
        DeterAmazonia,
        DeterCerrado,
        UnidadeConservacaoUs,
        UnidadeConservacaoPi,
        Queimadas,
        SitiosArqueologicos,
        FaixaFronteira,
        PocAreaPlantadaGameleira,
        ImovelRural,
        Biomas,
        IncraSigefPublico,
        IncraSigefPrivado,
        IncraAssentamentos,
        IncraQuilombolas,
        QuilombolasMaranhao,
        DesmatamentoMapbiomas,
        Fonte,
        AreaRelevanteInteresseEcologicoArie,
        AreaProtecaoAmbientalApa,
        AppCamada,
        ReservaLegal,
        UnidadeConservacao,
        AreaPlantadaSojaCarMapbiomas,
        AreaEmbargadaSedamRo,
        ListaAreaEmbargadaSemaMt,
        AreaEmbargadaGdf,
        TermoEmbargoIpaam,
        AutosInfracaoFiscalizacaoIpaam,
        AutosEmbargosIpaamPol,
        EmbargosRemotosIpaam,
        AutoInfracaoGoPoligono,
        AutoInfracaoGoPonto,
        AutoInfracaoIpaam,
        EmbargosEmergenciaisIpaam,
        AreaEmbargadaAutoInfracaoSp,
        AreaEmbargadaRs,
        AreaEmbargadaGoPonto,
        AreasEmbargadasTo,
        AutoInfracaoTo,
        CsaCerrado,
        EmbargosGoLista,
        AutoInfracaoRs,
        QuilombolasBa,
        AutoInfracaoPi,
        AreaEmbargadaPa,
        AreaEmbargadaCePonto,
        AreaEmbargadaCe,
        AreaEmbargadaIbamaPoligonoPamgia,
        AreaEmbargadaRo,
        AreaEmbargadaRoPonto,
        ControleDesmatamentoAmazonia,
        ControleDesmatamentoAmazoniaPontos,
        ControleDesmatamentoAmazoniaConsolidada,
        AreaPlantadaBunge2024,
        AreaPlantadaBunge2025,
        AreaPlantadaBunge2026,
        SojaEmProdes2425,
        ProtocoloVerdeGraosStatusOk,
        ProtocoloVerdeGraosStatusRestricao,
        TerraIndigenaStatusDelimitado,
        TerraIndigenaStatusDeclarado,
        EmbargoGoInaConsultaLista,
        DenunciasProdutoresBunge
    },
    emits: ['handleCloseModalAnaliseElegibidade'],
    props: {
        show: {
            type: Boolean
        },
        dados: {
            type: Object
        },
        idMapa: {
            type: String
        }
    },
    data() {
        return {
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: false,
                diagnostico: false
            },
            collapseAtivo: '',
            collapseAtivoPessoa: '',
            refMapa: null,
            limiteRaio: 200,
            carregandoProdutividade: false,
            dadosProdutividade: {
                estado: {
                    nome: ''
                },
                area: null,
                areaUnidadeMedida: '',
                produtividade: null,
                produtividadeUnidadeMedida: '',
                capacidadeProdutiva: null,
                capacidadeProdutivaUnidadeMedida: '',
                calculoSaca: {
                    mediaRegional: null,
                    produtividade: null
                },
                fatorProdutividade: null,
                fonteDados: {
                    id: null,
                    nome: '',
                    sigla: ''
                }
            },
            classeDiagnosticoCar: 'INDEFINIDO',
            classeDiagnostcoRepresentante: '',
            restricaoRepresentante: false,
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: 'Conforme'
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                },
                INDEFINIDO: {
                    corClasse: '',
                    status: ''
                }
            },
            statusElegibilidade: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.comAlerta'
                    )
                }
            }
        };
    },
    computed: {
        capacidadeProdutivaFatorProdutividade() {
            return formatters.formatNumber(
                this.dadosProdutividade.fatorProdutividade + 1,
                2
            );
        }
    },
    watch: {
        show: function () {
            if (!this.show) return;
            this.mostrarTerritorioNoMapa();
            this.buscaProdutividadeCar();
            this.definirStatusCar();
            this.definirStatusRepresentante();
        },
        '$i18n._vm.locale': function () {
            this.updateStatusElegibilidade();
        }
    },
    methods: {
        handleCloseModal() {
            this.$emit('handleCloseModalAnaliseElegibidade');
        },
        mostrarTerritorioNoMapa() {
            this.refMapa = this.$refs['mapa'];

            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território analisado',
                geoJson:
                    this.dados.dadosDiagnostico?.diagnosticoCar.imovel.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes,
            index
        ) {
            let geoJson =
                restricao.geometry ||
                restricao.geometria ||
                restricao.properties?.geometry ||
                restricao.properties?.geometria ||
                restricao.propriedade?.geometry ||
                restricao.propriedade?.geometria ||
                geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                !geoJson &&
                restricao.properties?.latitude &&
                restricao.properties?.longitude
            ) {
                geoJson = {
                    type: 'Point',
                    coordinates: [
                        restricao.properties.longitude,
                        restricao.properties.latitude
                    ]
                };
            }
            this.refMapa = this.$refs['mapa'];

            this.refMapa.aplicarZoomGeoJson(geoJson);
        },
        prepararComponente(diagnostico) {
            if (!diagnostico.camada.codigo) return;
            if (diagnostico.camada.codigo === 'Áreas embargadas') {
                diagnostico.camada.nome += ' (IBAMA)';
            }
            if (diagnostico.camada.codigo === 'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS') {
                diagnostico.camada.nome = 'Controle Desmatamento Amazônia - Lista';
            }
            if (diagnostico.camada.codigo === 'APP') {
                return 'appCamada';
            }

            const partes = diagnostico.camada.codigo.split('_');
            const resultado = partes.map(parte => {
                return (
                    parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase()
                );
            });
            return resultado.join('');
        },
        prepararDadosParaComponente(diagnostico) {
            return {
                restricoes: diagnostico.resultados,
                geometria: diagnostico.geometria,
                habilitarZoomRestricao: true,
                cpfCnpj: diagnostico.cpfCnpj
            };
        },
        removerRestricoesNoMapa() {
            this.layersMaps = this.layersMaps.filter(
                layer => layer.name === `Território analisado`
            );
        },
        async buscaProdutividadeCar() {
            this.carregandoProdutividade = true;
            this.dadosProdutividade = {
                estado: {
                    nome: ''
                },
                area: null,
                areaUnidadeMedida: '',
                produtividade: null,
                produtividadeUnidadeMedida: '',
                capacidadeProdutiva: null,
                capacidadeProdutivaUnidadeMedida: '',
                calculoSaca: {
                    mediaRegional: null,
                    produtividade: null
                },
                fatorProdutividade: null,
                fonteDados: {
                    id: null,
                    nome: '',
                    sigla: ''
                }
            };
            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscaProdutividadeCar(
                        this.dados.dadosBuscaSaldo.codigoCar,
                        this.dados.dadosBuscaSaldo.cultura.codigo,
                        this.dados.safraNome
                    );
                this.dadosProdutividade = data;
            } catch (error) {}
            this.carregandoProdutividade = false;
        },
        definirStatusRepresentante() {
            if (this.dados.dadosDiagnostico?.diagnosticoRepresentante.length) {
                this.restricaoRepresentante = false;
                this.dados.dadosDiagnostico.diagnosticoRepresentante.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta !== 'BAIXO') {
                            this.restricaoRepresentante = true;
                        }
                    }
                );
            }
        },
        definirStatusCar() {
            this.classeDiagnosticoCar = 'INDEFINIDO';
            let laranja = false;
            let vermelho = false;
            let amarelo = false;
            if (
                this.dados.dadosDiagnostico?.diagnosticoCar.diagnosticos.length
            ) {
                this.dados.dadosDiagnostico.diagnosticoCar.diagnosticos.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta === 'ALTO') {
                            vermelho = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO') {
                            amarelo = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO_ALTO') {
                            laranja = true;
                        }
                    }
                );
            }
            if (vermelho) {
                this.classeDiagnosticoCar = 'ALTO';
            } else if (laranja) {
                this.classeDiagnosticoCar = 'MEDIO_ALTO';
            } else if (amarelo) {
                this.classeDiagnosticoCar = 'MEDIO';
            } else {
                this.classeDiagnosticoCar = 'BAIXO';
            }
        },
        exibirSatausSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.ativo'
                    );
                case 'CA':
                    return this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.cancelado'
                    );
                case 'PE':
                    return this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.pendente'
                    );
                case 'SU':
                    return this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.suspenso'
                    );
                default:
                    return situacao;
            }
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },
        exibirRestricoesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivo === 'string' &&
                this.collapseAtivo === ''
            ) {
                return;
            }

            const areas =
                this.dados.dadosDiagnostico?.diagnosticoCar.diagnosticos[
                    this.collapseAtivo
                ].resultados.filter(
                    resultado =>
                        resultado.geometria ||
                        resultado.geometry ||
                        (resultado.properties.latitude &&
                            resultado.properties.longitude)
                );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivo,
                            group: `grupo-restricoes-${this.collapseAtivo}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-${this.collapseAtivo}`,
                                indexDiagnostico: this.collapseAtivo,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-${this.collapseAtivo}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        updateStatusElegibilidade() {
            this.statusElegibilidade.ELEGIVEL.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.elegivel'
            );
            this.statusElegibilidade.INELEGIVEL.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.inelegivel'
            );
            this.statusElegibilidade.ALERTA.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.comAlerta'
            );
        }
    }
};
</script>
<style lang="scss">
.modal-analise-elegibilidade {
    .status-amarelo {
        color: #bfae19;
        font-weight: 600;
    }

    .status-laranja {
        color: var(--warning);
        font-weight: 600;
    }

    .status-danger {
        color: var(--danger);
        font-weight: 600;
    }

    .status-sucess {
        color: var(--green);
        font-weight: 600;
    }

    .el-dialog__body {
        padding: 14px 15px;
        height: 515px;
    }

    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: #f6f6f6;
        color: #3b3b3b;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }

    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;

        .analise-elegibilidade--header__status {
            margin-left: 4px;
            display: flex;
            gap: 40px;

            .analise-elegibilidade--header__status-diagnostico {
                span {
                    margin-left: 4px;
                }
            }
        }
    }

    .direita-sub-title {
        font-weight: bold;
        color: #3b3b3b;
        font-size: 15px;
        margin-bottom: 8px;
        margin-top: 8px;
    }

    .modal-analise-elegibilidade--sub-title,
    .bloco-capacidade-produtiva--sub-title {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .modal-analise-elegibilidade--body {
        height: 495px;
        display: flex;
        justify-content: space-between;
        gap: 1%;

        .direita.lista-scroll {
            width: 52%;
            max-height: 495px;
            overflow: auto;
        }

        .esquerda {
            width: 47%;

            .mapa-elegibilidade {
                height: 100%;
                min-height: 568px;
                border-radius: 4px;
                overflow: hidden;
                margin: 0px 0 9px 0;
            }

            .bloco-distancia {
                min-height: 116px;
            }
        }

        .modal-analise-bloco-lista-scroll {
            overflow-y: auto;
            max-height: 230px;
            padding: 5px 0px;
        }

        .modal-analise-bloco-bloco--title {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .modal-analise-bloco {
            background: #f7f6f6;
            border-radius: 5px;
            padding: 12px 11px;

            &.modal-analise-bloco__baixo {
                margin-top: 18px;
            }

            .modal-analise-bloco-cpf-cnpj {
                .titulo {
                    color: #183b57;
                    font-weight: bold;
                    margin-right: 5px;
                }
            }

            .modal-analise-bloco--title {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #3b3b3b;
                margin-bottom: 13px;
                gap: 4px;
            }

            .container-sem-restricoes {
                p {
                    margin-left: 20px;
                }
            }

            .modal-analise-bloco--conteudo,
            .bloco-capacidade-produtiva--conteudo {
                display: flex;
                gap: 20px;
                justify-content: flex-start;
                flex-wrap: wrap;
            }

            .bloco-capacidade-produtiva--conteudo--interno,
            .bloco-capacidade-produtiva--conteudo--interno {
                margin-bottom: 5px;
                display: flex;
                flex-direction: column;
            }

            .modal-analise-bloco--conteudo--interno--title,
            .bloco-capacidade-produtiva--conteudo--title,
            .bloco-distancia--conteudo--title,
            .modal-analise-bloco--title--car {
                color: #183b57;
                font-weight: bold;
            }

            .bloco-capacidade-produtiva--conteudo-baixo {
                display: flex;
                justify-content: flex-start;
                gap: 20px;
                flex-wrap: wrap;

                .bloco-capacidade-produtiva--conteudo-baixo--interno {
                    display: flex;
                    flex-direction: column;
                }
            }
        }

        .el-collapse-item__header {
            background-color: #f7f6f6;
            color: #3b3b3b;
        }

        .el-collapse-item__content {
            background: #f7f6f6;
        }

        .custon-icon-collapse--grande {
            font-size: 18px;
        }

        .custon-icon-collapse--menor {
            font-size: 13px;
        }
    }

    .el-dialog.is-fullscreen {
        .modal-analise-bloco-lista-scroll {
            max-height: 550px !important;
        }
    }

    .modal-anotacao-footer {
        display: flex;
        justify-content: space-between;
    }

    .el-alert__title {
        color: #3b3b3b;
        font-weight: bold;
    }

    i.custon-icon-collapse--menor {
        margin-right: 4px;
    }

    .lista-scroll::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    i {
        font-weight: 600;
    }
}
</style>
